@if (loading$ | async) {
<div class="spinner-backdrop">
    <img src="assets/images/Yaldi-Logo-transparent.gif" class="spinner-logo" alt="spinner" />
</div>
}